import { render, staticRenderFns } from "./ClienteTabPreco.vue?vue&type=template&id=f5411c66&scoped=true"
import script from "./ClienteTabPreco.vue?vue&type=script&lang=js"
export * from "./ClienteTabPreco.vue?vue&type=script&lang=js"
import style0 from "./ClienteTabPreco.vue?vue&type=style&index=0&id=f5411c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5411c66",
  null
  
)

export default component.exports